// Цвета в стиле Telegram — те же палитры и правила выбора, что в KMP-клиенте
// (BubbleLogic.kt `senderColor`, Avatar.kt `colorForKey`), чтобы у человека был один цвет везде.

/** Как `String.hashCode()` в JVM: h = 31*h + charCode, 32-битное знаковое целое. */
export function javaHashCode(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  return h;
}

const SENDER_PALETTE = ['#FF7A6B', '#FFB454', '#9BDB6A', '#4FD1C5', '#5EB5F7', '#B190FF', '#F58FCB'];

const AVATAR_PALETTE = ['#8B5CF6', '#EF4444', '#F59E0B', '#10B981', '#3B82F6', '#EC4899', '#14B8A6', '#F97316'];

/** Цвет имени автора в группе по id отправителя. */
export function senderColor(senderId?: string | null): string {
  if (!senderId) return SENDER_PALETTE[0];
  const n = SENDER_PALETTE.length;
  return SENDER_PALETTE[((javaHashCode(senderId) % n) + n) % n];
}

/** Фон аватарки-заглушки по ключу (id чата/пользователя). `abs(Int.MIN_VALUE)` в Kotlin остаётся отрицательным — повторяем. */
export function avatarColor(key: string): string {
  const h = javaHashCode(key);
  const abs = h === -2147483648 ? h : Math.abs(h);
  const n = AVATAR_PALETTE.length;
  return AVATAR_PALETTE[((abs % n) + n) % n];
}
